import PropTypes from 'prop-types';

export const FIXTURE_SUMMARY_STATISTICS = PropTypes.shape({
  played: PropTypes.number,
  W: PropTypes.number,
  L: PropTypes.number,
  D: PropTypes.number,
});

export const FIXTURE_POINTS = PropTypes.shape({
  fixture_id: PropTypes.string.isRequired,
  points: PropTypes.string,
  summary: PropTypes.string,
});

export const POINTS_BY_FIXTURE = PropTypes.arrayOf(FIXTURE_POINTS);

export const FIXTURE_STATISTICS_BREAKDOWN = PropTypes.shape({
  total_points: PropTypes.number,
  max_points: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  average_points: PropTypes.string,
  average_opposition_points: PropTypes.string,
  points_by_fixture: POINTS_BY_FIXTURE,
});

export const KEY_PLAYER_STATISTICS = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    players: PropTypes.arrayOf(
      PropTypes.shape({
        profile_id: PropTypes.string,
        profile_type: PropTypes.string,
        name: PropTypes.string,
        position: PropTypes.string,
        img_url: PropTypes.string,
      }),
    ),
    value: PropTypes.number,
  }),
);

export const PLAYER_STATISTICS_TABLES = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    table: PropTypes.shape({
      fields: PropTypes.shape(),
      rows: PropTypes.arrayOf(PropTypes.shape()),
    }),
    key: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
);
